module.exports = __webpack_public_path__ + "static/media/disabledDisconnectionIcon.31a3e965.svg";